import { AxiosError } from 'axios'
import { Box, Flex } from 'components/elements'
import { DetailContainer, InfoColumn, MainWrapCSS } from 'features/incidents/components/style'
import { ErrorBox } from 'features/profile/components/EditProfileForm'
import { BoxCss, Notification, textCss } from 'features/quote/components/GetAQuoteProcess/QuoteReview'
import { PaymentProps } from 'features/quote/components/type'
import { useState, useEffect } from 'react'
import { errorMessage, getUpperCase } from 'utils/function'
import { useChangePolicy } from 'features/insurance/api/changePolicy'
import { ModalEnum } from 'features/incidents/components/enums'
import { userRegHeadingCss } from 'views/style'
import { Stages } from 'utils/enum'
import StripePayment from './StripePayment'

export const ChangePolicyPayment = (props: PaymentProps) => {
  const { quoteUserReg, setQuoteUserReg, setStage, setOpenModal, setNotification } = props
  const [submitError, setSubmitError] = useState('')
  const quotedPremiumDiscount = quoteUserReg?.premiumInfo

  const { mutate, isLoading } = useChangePolicy()

  const IsOpenInModal = true
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const doc: Document = document
  const body = doc.querySelector('body')

  const handleStripeSubmit = (paymentMethodId: string) => {
    const newObj = {
      planId: quoteUserReg?.planId,
      services: quoteUserReg?.service,
      paymentMethodId,
      isAutoSubscriptionEnabled: true,
      annualRevenue: quoteUserReg?.annualRevenue,
      coverageId: quoteUserReg?.coverageId,
      paymentPeriod: quoteUserReg?.period,
    }

    mutate(newObj, {
      onSuccess: () => {
        body?.classList.remove('overflow--hidden--modal')
        setStage?.(Stages.STAGE1)
        setQuoteUserReg?.({})
        setOpenModal?.({ label: '', isOpen: false })
        setNotification?.(ModalEnum.CHANGE_POLICY)
      },
      onError: error => {
        if (error instanceof AxiosError) {
          setSubmitError(errorMessage(error))
        }
      },
    })
  }
  const handleCancel = () => {
    setQuoteUserReg?.({})
    setOpenModal?.({ label: '', isOpen: false })
    setStage?.(Stages.STAGE1)
  }

  return (
    <>
      <Flex align="center">
        <Flex as="h2" justify={'center'} css={userRegHeadingCss}>
          Stripe Payment
        </Flex>
      </Flex>
      <Flex justify={'between'} wrap={'wrap'} css={{ mb: '$3', rowGap: '1rem' }}>
        <Box as="h4" css={{ textAlign: 'start', m: 0 }}>
          Payment Information
        </Box>
        {quotedPremiumDiscount && quotedPremiumDiscount?.discountPercent > 0 && (
          <Notification>
            <Box as="span" css={{ textAlign: 'center' }}>
              You saved {quoteUserReg?.premiumInfo?.discountPercent}%
            </Box>
          </Notification>
        )}
      </Flex>
      <Flex>
        {quoteUserReg?.premiumInfo && (
          <Box
            className="detail-box"
            style={{ padding: 0 }}
            css={{
              ...MainWrapCSS,
              background: '$cardGradient',
              borderRadius: '8px',
              mb: '$5',
            }}
          >
            <DetailContainer className="custom--grid">
              <InfoColumn css={BoxCss}>
                <Box as="p" className="t-title m-0">
                  Original Premium{' '}
                </Box>
                <Box as="p" className={`t-value `} css={textCss}>
                  ${quoteUserReg?.premiumInfo.premium}
                </Box>
              </InfoColumn>
              <InfoColumn css={BoxCss}>
                <Box as="p" className="t-title m-0" css={{ wordBreak: 'auto-phrase !important' }}>
                  Discounted Premium
                </Box>
                <Box as="p" className={`t-value `} css={{ ...textCss, color: '$primary', fontSize: '$xl' }}>
                  ${quoteUserReg?.premiumInfo.discountValue}
                </Box>
              </InfoColumn>
            </DetailContainer>
          </Box>
        )}
      </Flex>
      <Box as="h4" css={{ textAlign: 'start' }}>
        Card Information
      </Box>

      <Flex direction="column" css={{ gap: '$5' }}>
        {!!submitError && <ErrorBox css={{ textAlign: 'left', mb: '$3' }}>{getUpperCase(submitError)}</ErrorBox>}
        <StripePayment onSubmit={handleStripeSubmit} isLoading={isLoading} IsOpenInModal={IsOpenInModal} handleCancel={handleCancel} />
      </Flex>
    </>
  )
}
